import { Button } from "@mui/material";
import { CONFIG_APP_BASE_COMPANY, CONFIG_APP_UPTIME_METRICS_BASE_URL } from "../../configApp";
import { OpenInNew } from "@mui/icons-material";
import axios from "axios";
import { useState, useEffect } from "react";
import { RiTimer2Line } from "react-icons/ri";
import { CustomTooltip } from "../Settings/Organization";

// Function to get the app port
function getAppPort(name) {
  return axios.get(`${CONFIG_APP_UPTIME_METRICS_BASE_URL}/get-app-port?name=${name}`)
    .then(response => response.data.port)  // Assuming response contains { port: number }
    .catch(error => {
      console.error("Error fetching the port:", error);
      return null;  // If there's an error, return null
    });
}

export default function AppOpenInLink({ data }) {
  const [port, setPort] = useState(null);

  useEffect(() => {
    if (CONFIG_APP_BASE_COMPANY === "zeke" && data?.row?.name) {
      getAppPort(data.row.name).then(fetchedPort => {
        setPort(fetchedPort);  // Store the port in the state
      });
    }
  }, [data]);


  // Check if the app is deployed or not
  const isDeployed = data.value !== "nife.io";

  return (
    <div style={{ textAlign: "left" }}>
      {/* If company is "zeke", show the app with port or fallback */}
      {CONFIG_APP_BASE_COMPANY === "zeke" ? (
        <>
          {isDeployed ? (
            port ? (
              <Button
                endIcon={<OpenInNew />}
                size="small"
                onClick={() => window.open(`http://10.20.153.123:${port}`, '_blank')}
              >
                Open App
              </Button>
            ) : (
              <span>Loading port...</span>
            )
          ) : (
            <span>Not Deployed</span>
          )}
        </>
      ) : (
        // Original behavior for other companies
        isDeployed ? (
        


   new Date().getTime() - new Date(data?.row?.createdAt).getTime()) / 1000 >= 180 ? (
  <Button endIcon={<OpenInNew />}  onClick={() => window.open(data.value, '_blank')} className="btn btn-primary">
    Open App
  </Button>
) : (
  <CustomTooltip title="App is getting ready… Please wait a few seconds.">
<Button
  startIcon={
    <RiTimer2Line
      style={{
        animation: 'spin 1.2s linear infinite',
      }}
    />
  }
  sx={{
    fontSize: '10px',
    textTransform: 'capitalize',
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  }}
>
 getting ready
</Button>
  </CustomTooltip>


        ) : (
          "Not Deployed"
        )
      )}
    </div>
  );
}
